var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6Z",
    fill: "#A5A6BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62132 6.07843C8.62132 6.35457 8.39746 6.57843 8.12132 6.57843L5.79289 6.57843C5.51675 6.57843 5.29289 6.35457 5.29289 6.07843L5.29289 4.16421C5.29289 3.88807 5.51675 3.66421 5.79289 3.66421C6.06904 3.66421 6.29289 3.88807 6.29289 4.16421L6.29289 5.57843L8.12132 5.57843C8.39746 5.57843 8.62132 5.80228 8.62132 6.07843Z",
    fill: "#A5A6BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldTime);
export default __webpack_public_path__ + "static/media/old-time.f29577da74f776d997c25a2421883a2c.svg";
export { ForwardRef as ReactComponent };